export const DateFormatTypesArray = ['DMY', 'MDY', 'YMD'] as const;
export type DateFormatType = (typeof DateFormatTypesArray)[number];

export const TimeFormatTypesArray = ['H24', 'H12'] as const;
export type TimeFormatType = (typeof TimeFormatTypesArray)[number];

export const NumberFormatTypesArray = ['US', 'DE', 'UK'] as const;
export type NumberFormatType = (typeof NumberFormatTypesArray)[number];

export function formatDate(date: string | Date | null | undefined, format: DateFormatType): string {
  if (!date) {
    switch (format) {
      case 'DMY':
        return '  /  /    ';
      case 'MDY':
        return '  /  /    ';
      default:
        return '    -  -  ';
    }
  }
  if (typeof date === 'string') {
    date = new Date(date);
  }
  const d = date;

  switch (format) {
    case 'DMY':
      return (
        String(d.getDate()).padStart(2, '0') + '/' + String(d.getMonth() + 1).padStart(2, '0') + '/' + d.getFullYear()
      );
    case 'MDY':
      return (
        String(d.getMonth() + 1).padStart(2, '0') + '/' + String(d.getDate()).padStart(2, '0') + '/' + d.getFullYear()
      );
    default:
      return (
        d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0') + '-' + String(d.getDate()).padStart(2, '0')
      );
  }
}

export function formatTime(date: string | Date | null | undefined, format: TimeFormatType): string {
  if (!date) {
    return '??:??';
  }
  if (typeof date === 'string') {
    date = new Date(date);
  }
  const d = date;
  const hours = d.getHours();
  const minutes = d.getMinutes();

  const ampm = hours >= 12 ? 'pm' : 'am';
  const formattedHours = format === 'H12' ? hours % 12 || 12 : hours;
  const formattedMinutes = String(minutes).padStart(2, '0');

  return format === 'H12'
    ? `${formattedHours}:${formattedMinutes} ${ampm}`
    : `${String(formattedHours).padStart(2, '0')}:${formattedMinutes}`;
}

export function formatNumber(number: number | null | undefined, decimals = 0, format: NumberFormatType): string {
  if (number === undefined || number === null) {
    return decimals ? '???.'.padEnd(decimals + 3, '0') : '???';
  }
  return new Intl.NumberFormat(format, {
    style: 'decimal',
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  }).format(number);
}
